// src/pages/Utilisateurs/PrepaPhysique/components/DoneSwitch.jsx

import React from "react";

export default function DoneSwitch({ checked, onChange, disabled, title }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={
        title || (checked ? "Exercice effectué" : "Exercice non effectué")
      }
      title={title || (checked ? "Exercice effectué" : "Exercice non effectué")}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onChange?.();
      }}
      className={`relative inline-flex h-7 w-[52px] items-center rounded-full transition ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      } ${checked ? "bg-emerald-500" : "bg-slate-300 dark:bg-slate-700"}`}
    >
      <span
        className={`inline-block h-6 w-6 transform rounded-full bg-white shadow transition ${
          checked ? "translate-x-6" : "translate-x-0.5"
        }`}
      />
    </button>
  );
}